import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopEmployersByISCED4 = async (HubIds: string[], ISCED4Codes: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.educationCareerPath.getTopEmployersByISCED4;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}`,
        method,
        { HubIds, ISCED4Codes, Locations, fromQuarter, toQuarter, isEntryLevel },
        {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
